import { Box, Chip, Stack, Typography } from '@mui/material';
import { useBookingFlowContext } from '../../../booking-flow/BookingFlowProvider';
import { BookingConfirmation } from '../../../components/booking/BookingConfirmation';
import { formatMoney } from '../../../components/booking/money';
import type { TransferFlowState } from '../flowConfig';

export function TransferDocumentStep() {
  const flow = useBookingFlowContext<TransferFlowState>();
  const booking = flow.state.cart?.transferBookings?.[0];
  const isFinalized = !!flow.state.cart?.isFinalized;

  const references = [
    booking?.pnr ? { label: 'PNR', value: booking.pnr } : null,
    booking?.referenceNumber ? { label: 'Referans No', value: booking.referenceNumber } : null,
    flow.state.shoppingCartId ? { label: 'Sepet No', value: String(flow.state.shoppingCartId) } : null,
  ].filter((r): r is { label: string; value: string } => r !== null);

  return (
    <BookingConfirmation
      status={isFinalized ? 'success' : 'partial'}
      title="Rezervasyon Belgesi"
      message={isFinalized ? 'Rezervasyon kesinleştirildi.' : 'Rezervasyon henüz kesinleşmedi.'}
      references={references}
      summary={
        <Stack spacing={1}>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {booking?.status && <Chip size="small" label={`Durum: ${booking.status}`} />}
            {booking?.provider && <Chip size="small" label={`Sağlayıcı: ${booking.provider}`} />}
          </Box>
          <Typography variant="body2">
            Toplam Tutar: {formatMoney(booking?.totalFare, booking?.currency)}
          </Typography>
        </Stack>
      }
      primaryAction={{ label: 'Yeni Arama', onClick: flow.reset }}
    />
  );
}
